// import React, { useState, useCallback, useEffect } from "react";

import {
    Chip
} from '@mui/material';

export default function RequestStatusBadge({ item }) {

    if (item?.attempt_no === "0") {
        return (
            <Chip
                size="small"
                label={`Waiting`}
                color="default"
                variant="contained"
            />
        )
    }

    if (item?.attempt_status === "1") {
        return (
            <Chip
                size="small"
                label={`Success`}
                color="primary"
                variant="contained"
            />
        )
    }

    return (
        <Chip
            size="small"
            label={`Failed`}
            color="error"
            variant="contained"
        />
    )
}